import axios from 'axios';

import config from '@/config/config';
import { headers } from './auth.headers';
import { formatQueryString } from '@/helpers/query-string';
import { ICompanyType } from '@/domain/company-type.model';
import { IPaginateVueTable } from '@/interfaces/IPaginateVueTable';

const url_api_base = config.url_api_cliente;

export const insert = (data: ICompanyType): Promise<ICompanyType> => {
  return axios.post(`${url_api_base}/company-type`, data, headers());
};

export const update = (data: ICompanyType): Promise<ICompanyType> => {
  return axios.patch(`${url_api_base}/company-type/${data.id}`, data, headers());
};

export const get = (id: string): Promise<ICompanyType> => {
  const url = `${url_api_base}/company-type/${id}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const list = (
  offset?: number,
  limit?: number,
  order?: string,
  sort?: string,
  filter?: string,
): Promise<IPaginateVueTable<ICompanyType>> => {
  const query = formatQueryString(offset, limit, order, sort, filter);
  const url = `${url_api_base}/company-type${query}`;

  return axios.get(url, headers()).then((res) => res?.data);
};
